import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=77e1e757&scoped=true&lang=css"

import exportComponent from "C:\\Users\\liuqi\\Desktop\\R\\website-vue3-antd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e1e757"]])

export default __exports__